<div class="growerProgramLanding seed-return-wrapper">
  <div class="GrowerProgramLandingPage">
    <div class="row extraWidth">
      <div class="col-9 margin-l0 TopSec">
        <div class="row">
          <div class="col-8">
            <h3>
              Manage Your Budgeted Spends
              <span class="d-inline-block d-md-none"><i class="fas fa-regular fa-info-circle"></i></span>
            </h3>
          </div>
        </div>
        <p class="smalltext">
          Use this screen to record a new spend or update an existing spend against your assigned budgets. For any missing budgets or issues reach out to Grower Program customer service team.
        </p>
      </div>
      <div class="text-right col-3 m-auto" *ngIf="growerProgramData?.data">
        <h3 class="padding-r10" style="font-size: 1.2rem;">
          Subscription Status:
          <span (click)="updateReportingSubscriptionStatus()" matTooltip=" This option would provide you with a copy of the GP report to your email address" [matTooltipPosition]="'below'" matTooltipClass='whiteFontCpp' [ngClass]="{'highlight-red': reportingSubscriptionStatus === false, 'color-primary': reportingSubscriptionStatus === true}" class="handCursor"> {{reportingSubscriptionStatus ? "Subscribed" : "Unsubscribed"}}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col-10">
        <app-filter [optionsData]="filterOptionsData" [isShowFilterButton]="false" [isSearchButtonOutside]="true" [isDisableSearchButton]="!isMasterDataLoaded" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
      <div class="col-2 margin-l-rem padding-l0">
        <div class="row">
          <div class="col-6">
            <button *ngIf="isBudgetExists && !isReadOnlyAccess" mat-raised-button [disabled]="!isMasterDataLoaded" class="btns export-button margin-t12 w100 font-14" [matMenuTriggerFor]="menu">Export</button>
            <mat-menu #menu="matMenu" xPosition="after" class="matDropDownMenu mainNavDropDown report-export-btn">
              <button mat-menu-item (click)="exportDataTemplate(true)">Upload Template</button>
              <button *ngIf="hasSpendBudget" mat-menu-item (click)="exportDataTemplate(false)">Search Results</button>
              <button *ngIf="manualOrderExtractionEnable && manualOrderExtractionEnablecb"  (click)="saveManualExtractionData()" mat-menu-item>Manual Order Extraction</button>
            </mat-menu>
          </div>
          <div class="col-6">
            <button *ngIf="isBudgetExists && !isReadOnlyAccess" mat-raised-button [disabled]="!isMasterDataLoaded" class="btns export-button margin-t12 w100 font-14" (click)="importGrowerProgramPopup()">Import</button>

          </div>
        </div>

      </div>
    </div>

    <div class="row add-products-section">
      <div class="col-3 padding-r0">
        <mat-checkbox *ngIf="growerProgramData?.filteredData?.length > 0 && !isReadOnlyAccess" #AllProductCheck class="custom-checkbox select-all-check"
                      [checked]="(isAllAccountsChecked) || growerProgramData?.filteredData?.length === selectedCount" id="chkSelectAll"
                      [style.display]="disablecheckbox ? 'none' : 'block'"
                      [indeterminate]="checkBoxCount > 0 && checkBoxCount < growerProgramData?.filteredData?.length"
                      (change)="enableAllCheckBoxes(!isAllAccountsChecked)"
                      title="Select All Lines"></mat-checkbox>

        <div class="product-tools-outer" *ngIf="showTabs && (!isSearchClicked && editToolKit) && !isReadOnlyAccess">
          <div class="product-tools-tab" appClickOutside (clickOutside)="clickOutsideReset()">
            <div class="tab-bar col-md-10 margin-l20">
              <ul>
                <li *ngIf="showDelete" (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator" matTooltip="Delete records from Grid" [matTooltipPosition]="'above'" matTooltipClass='whiteFontCpp'>
                  <i class="trash-icon"></i>
                </li>
                <li *ngIf="showSubmit" (click)="showTab('submit')" [ngClass]="{'active': tabNode==='submit'}" class="seperator" matTooltip="Submit Spends" [matTooltipPosition]="'above'" matTooltipClass='whiteFontCpp'>
                  <i class="submit-icon"></i>
                </li>
                <li *ngIf="showVoid" (click)="showTab('void')" [ngClass]="{'active': tabNode==='void'}" class="seperator" matTooltip="Void" [matTooltipPosition]="'above'" matTooltipClass='whiteFontCpp'>
                  <i class="void-icon"></i>
                </li>
                <li *ngIf="hasPendingSpendForApproval && showApproveReject" (click)="showTab('approve')" [ngClass]="{'active': tabNode==='approve'}" class="seperator" matTooltip="Approve Spends" [matTooltipPosition]="'above'" matTooltipClass='whiteFontCpp'>
                  <i class="approve-icon"></i>
                </li>
                <li *ngIf="hasPendingSpendForApproval && showApproveReject" (click)="showTab('reject')" [ngClass]="{'active': tabNode==='reject'}" class="seperator" matTooltip="Reject Spends" [matTooltipPosition]="'above'" matTooltipClass='whiteFontCpp'>
                  <i class="reject-icon"></i>
                </li>
              </ul>
            </div>
            <div class="tab-content">
              <div *ngIf="tabNode==='delete'" class="delete-product">
                <div class="tab-content-detail">
                  <p>Are you sure you want to delete <span> {{selectedCount}} </span> selected Items(s)?</p>
                  <div class="btn-area">
                    <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="setAllFields(true)">Yes</button>
                    <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="setAllFields(false)">No</button>
                  </div>
                </div>
              </div>
              <div *ngIf="tabNode==='submit'" class="delete-product">
                <div class="tab-content-detail">
                  <p>Are you sure you want to submit <span> {{selectedCount}} </span> selected Items(s)?</p>
                  <div class="btn-area">
                    <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="approveRejectSubmit(true,'submit')">Yes</button>
                    <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="approveRejectSubmit(false)">No</button>
                  </div>
                </div>
              </div>
              <div *ngIf="tabNode==='approve'" class="delete-product">
                <div class="tab-content-detail">
                  <p>Are you sure you want to approve <span> {{selectedCount}} </span> selected Items(s)?</p>
                  <div class="btn-area">
                    <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="approveRejectSubmit(true,'approve')">Yes</button>
                    <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="approveRejectSubmit(false)">No</button>
                  </div>
                </div>
              </div>
              <div *ngIf="tabNode==='reject'" class="delete-product">
                <div class="tab-content-detail">
                  <p>Are you sure you want to reject <span> {{selectedCount}} </span> selected Items(s)?</p>
                  <div class="btn-area">
                    <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="approveRejectSubmit(true,'reject')">Yes</button>
                    <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="approveRejectSubmit(false)">No</button>
                  </div>
                </div>
              </div>
              <div *ngIf="tabNode==='void'" class="void-popup delete-product">
                <div class="tab-content-detail">
                  <h4> <i class="fa fa-exclamation-triangle"></i> Void Spend Confirmation</h4>
                  <p class="p-0 mb-2">Voiding this transaction cannot be undone or edited after submitted. Any payments made via JDE will need to be manually reversed.</p>
                  <p class="p-0 mb-2">Enter a void reason and click OK to proceed.</p>
                  <input type="text" placeholder="Enter Voiding Reason" id="txtVoidReason"  [(ngModel)]="voidReason"  maxlength="2000" />
                  <div class="btn-area">
                    <button mat-raised-button [disabled]="!voidReason?.trim()" class="btns normal-large-btn" (click)="updateVoidField(true)" color="primary">OK</button>
                    <button mat-raised-button class="btns normal-large-btn" (click)="updateVoidField(false)" color="primary">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-9 text-right" *ngIf="isBudgetExists">
            <div class="display-ib padding-r20">
              <div class="text-right">
                <app-auto-save-dynamic-timer [(showTimer)]="showTimer" caption="AUTOSAVING" [displaySecond]="autoCancelCounter"></app-auto-save-dynamic-timer>
              </div>
            </div>
            <div class="display-ib">
              <span *ngIf="isBudgetExists && !isReadOnlyAccess" [ngClass]="showOnlyActiveLines ? 'col-3' :'col-3'" class="padding-l0 padding-r0 margin-r15">
                <span class="padding-r10">DISPLAY: <b> {{showOnlyActiveLines?"Active Lines":"All Lines"}}</b> </span>
                <label class="switch">
                  <input type="checkbox" (click)="toggleShowActiveOnly()" [checked]="!showOnlyActiveLines">
                  <span class="slider round"></span>
                </label>
              </span>
              <button *ngIf="isBudgetExists && !isReadOnlyAccess" [disabled]="disableSaveButton || growerProgramData?.filteredData?.length == 0" mat-raised-button class="btns w100 margin-r15 font-14" (click)="saveData()">Save</button>
              <button *ngIf="isBudgetExists && !isReadOnlyAccess" [disabled]="!isMasterDataLoaded" mat-raised-button class="btns w150 font-14 margin-r15" (click)="resetGrid()">Reset Filters</button>
              <button *ngIf="isBudgetExists && !isReadOnlyAccess" [disabled]="!isMasterDataLoaded" mat-raised-button class="btns w180 font-14" (click)="onAddProduct()">Enter New Spend</button>
            </div>
      </div>
      <div class="col-10 text-right m-auto" *ngIf="!isBudgetExists && !hasPendingSpendForApproval">
        <label class="padding-b0" style="color:#eb6666">There are no programs and/ budgets are defined in the system. Please contact system administrator.</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 productTableOuter growerProgramCreateEditTable">
        <div class="tableContainer" id="growerProgramView">
          <table mat-table [dataSource]="growerProgramData" multiTemplateDataRows class="matTables productTable">
            <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
              <div *ngIf="column=='spendID'"></div>
              <div *ngIf="column=='checkbox'"><th mat-header-cell *matHeaderCellDef style="min-width: 50px !important"></th>
        </div>


        <div *ngIf="column=='budgetName'"><th mat-header-cell *matHeaderCellDef class="prod-name text-left">Budget Name</th></div>
        <div *ngIf="column=='programType'"><th mat-header-cell *matHeaderCellDef class="prod-name text-left">Program Type</th></div>
        <div *ngIf="column=='retailerName'"><th mat-header-cell *matHeaderCellDef class="prod-name text-left">Retailer Name</th></div>
        <div *ngIf="column=='initialBudget'"><th mat-header-cell *matHeaderCellDef class="prod-name text-center">Initial Budget</th></div>
        <div *ngIf="column=='remainingBudget'"><th mat-header-cell *matHeaderCellDef class="prod-name text-center">Remaining<div>Budget($)</div></th></div>
        <div *ngIf="column=='estimatedQuantity'"><th mat-header-cell *matHeaderCellDef class="prod-name text-center">Estimated<div>Quantity</div> </th></div>
        <div *ngIf="column=='estimatedSpend'"><th mat-header-cell *matHeaderCellDef class="prod-name text-center">Estimated Spend Amount($)</th></div>
        <div *ngIf="column=='parent'"><th mat-header-cell *matHeaderCellDef class="prod-name text-left">Parent</th></div>
        <div *ngIf="column=='grower'"><th mat-header-cell *matHeaderCellDef class="prod-name text-left">Grower</th></div>
        <div *ngIf="column=='seller'"><th mat-header-cell *matHeaderCellDef class="prod-name text-left">Seller</th></div>
        <div *ngIf="column=='budgetUser'"><th mat-header-cell *matHeaderCellDef class="prod-name text-left">SDM</th></div>
        <div *ngIf="column=='programName'">
          <th mat-header-cell *matHeaderCellDef class="prod-name text-left padding-l20">Program Name</th>
        </div>
        <div *ngIf="column=='salesChannel'"><th mat-header-cell *matHeaderCellDef class="prod-name text-left">Sales Channel</th></div>
        <div *ngIf="column=='marketingBrand'"><th mat-header-cell *matHeaderCellDef class="prod-name text-left">Marketing Brand</th></div>
        <div *ngIf="column=='productLine'"><th mat-header-cell *matHeaderCellDef class="prod-name text-left">Product Line</th></div>
        <div *ngIf="column=='cyOrder'"><th mat-header-cell *matHeaderCellDef class="prod-name text-center">CY Grower Orders</th></div>
        <div *ngIf="column=='status'"><th mat-header-cell *matHeaderCellDef class="prod-name text-center">Status</th></div>
        <div *ngIf="column=='responsible'"><th mat-header-cell *matHeaderCellDef class="prod-name text-center">Responsible</th></div>
        <div *ngIf="column=='approvedPayment'"><th mat-header-cell *matHeaderCellDef class="prod-name text-center">Approved Payment Amount($)</th></div>
        <div *ngIf="column=='customerCreditedAmount'"><th mat-header-cell *matHeaderCellDef class="prod-name text-center">Customer Credited Amount($)</th></div>
        <div *ngIf="column=='updateTimestamp'"><th mat-header-cell *matHeaderCellDef class="prod-name text-center">Last Updated</th></div>
        <div *ngIf="column=='comment'"><th mat-header-cell *matHeaderCellDef class="text-center"></th></div>
        <td mat-cell *matCellDef="let element;let i = dataIndex" [ngStyle]="getCellStyle(element.approvalStatus, element.status)">

          <div *ngIf="column=='checkbox' && !isReadOnlyAccess" class="col-12 material-select">
            <span style="display:inline-block" matTooltip="{{element.spendID != 0 ? element.spendID : ''}}"
                  matTooltipPosition="above"
                  matTooltipClass="gp-gray-tooltip">

              <mat-checkbox #SingleCheck
                            (change)="enableCheckBoxSingle(SingleCheck._checked)"
                            [(ngModel)]="element.isSelected"
                            class="custom-checkbox"
                            [disabled]="element.voided">
              </mat-checkbox>

            </span>
          </div>


          <div class="row grower-add-dropDown">
            <div *ngIf="column=='budgetName'" class="col-12  material-select deliveryInstructionsGrowerProgram">
              <div *ngIf="element.budgetID === null || element.spendID === 0">
                <ng-select name="ddlBudgetList"
                           [items]="element.budgetFilteredList"
                           [(ngModel)]="element.budgetID"
                           [clearable]="true"
                           class="custom-select-grower grower-add-drop custom-productline"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="id"
                           [closeOnSelect]="true"
                           [searchFn]="programAndBudgetSearch"
                           (change)="onGridBudgetChange($event, element,budgetFieldName, i)"
                           [disabled]="!isBudgetExists || element.isExistingRecord"
                           data-testid="ddl-budget-name-search"
                           matTooltip="{{element.budgetID != 0 ?element.budgetID : ''}}"
                           [matTooltipPosition]="'above'"
                           matTooltipClass='gp-gray-tooltip'
                           [placeholder]="element.budgetID > 0? '':'Type to Search'">
                  <ng-template ng-footer-tmp let-search="searchTerm">
                    <div class="custom-drop-footer">
                      <div class="row">
                        <div class="col-lg-8 d-none d-lg-block">
                          <button mat-raised-button class="btns" color="primary" (click)="openProgramBudgetSliderModel(element, i)">Show All</button>
                        </div>
                        <div class="col-lg-4 bold text-left">
                          Results : {{element.budgetFilteredList.length}}
                        </div>
                      </div>
                    </div>
                  </ng-template>

                </ng-select>
              </div>
              <div *ngIf="element.budgetID > 0 && element.spendID > 0"
                   matTooltip="{{element.budgetID}}"
                   [matTooltipPosition]="'above'"
                   matTooltipClass="gp-gray-tooltip">
                <span>{{searchBudgetName(element.budgetID, element.budgetFilteredList)}}</span>
              </div>
            </div>
          </div>

          <div *ngIf="column=='programType'" class="defaultCursor text-left padding-l5">
            {{element.programType}}
          </div>

          <div class="row grower-add-dropDown">
            <div *ngIf="column=='retailerName'" class="col-md-12 material-select deliveryInstructionsGrowerProgram">
              <div *ngIf="element.budgetID === null || element.retailerName === '' || element.spendID === 0">
                <ng-select name="ddlretailer"
                           [items]="element.retailerFilteredList"
                           class="custom-select-grower grower-add-drop cpp-return-shipto pb-1"
                           [virtualScroll]="true"
                           [(ngModel)]="element.retailerAccountNumber"
                           [clearable]="false"
                           bindLabel="accountName"
                           bindValue="accountNumber"
                           [closeOnSelect]="true"
                           [searchFn]="accountSearchFn"
                           (change)="onGridInputChangeRetailer($event, element,retailerFieldName, i)"
                           (clear)="onGridInputChangeRetailer($event, element,retailerFieldName, i)"
                           [disabled]="element.programMasterID === 0 || element.budgetID === null || !isBudgetExists || element.isExistingRecord"
                           data-testid="ddl-retailer-name-search"
                           matTooltipClass='gp-gray-tooltip'
                           [placeholder]="element.retailerAccountNumber > 0? '':'Type to Search'">
                  <ng-template ng-label-tmp let-item="item" let-index="index">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="mb-0 mt-2">
                            {{item.accountName}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <h4 class="name greenColor" [ngOptionHighlight]="search">
                            {{item.accountName}}
                          </h4>
                          <p class="address" [ngOptionHighlight]="search">
                            {{item.accountAddress1}},  {{item.accountCity}}, {{item.accountState}} - {{item.accountZipCode}}
                          </p>
                          <p class="phoneNo" [ngOptionHighlight]="search">
                            {{item.primaryPhoneNumber}}
                          </p>
                          <p class="grower-nos">
                            <span class="grower-gln" [ngOptionHighlight]="search">
                              Account #: {{item.accountNumber}}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-footer-tmp let-search="searchTerm">
                    <div class="custom-drop-footer">
                      <div class="row">
                        <div class="col-lg-8">
                          <button mat-raised-button class="btns w100" color="primary" (click)="openRetailerSearchSliderModel(i, element)">Show All</button>
                        </div>
                        <div class="col-lg-4 bold text-left">
                          Results : {{element.retailerFilteredList.length}}
                        </div>
                      </div>
                    </div>
                  </ng-template>

                </ng-select>
              </div>
              <div *ngIf="element.budgetID > 0 && element.spendID > 0">
                <span>{{searchRetailerName(element.retailerAccountNumber)}}</span>
              </div>
            </div>
          </div>

          <div *ngIf="column=='initialBudget'" class="defaultCursor text-center">
            {{element.initialBudgetAmount}}
          </div>

          <div *ngIf="column=='remainingBudget'" [ngClass]="{'negative': element.remainingBudget < 0}" class=" defaultCursor text-center">
            {{searchRemainingBudget(element.remainingBudget)}}
          </div>

          <div *ngIf="column=='estimatedQuantity'" class="text-center firstName w100">
            <div class="col-md-12 customerPO">
              <mat-form-field class="wide100">
                <input matInput type="text" name="firstName" class="pb-1 text-center"
                       [(ngModel)]="element.estimatedQuantity"
                       autocomplete="new-username"
                       (keypress)="validateDecimal($event, element)"
                       data-testid="ddl-estimated-quantity-search"
                       [disabled]="element.voided || element.retailerAccountNumber == 0 || element.retailerAccountNumber == '' || element.retailerAccountNumber == undefined || !isBudgetExists || isReadOnlyAccess || element.isSpendDisabled">
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="column=='estimatedSpend'" class="text-center firstName w100">
            <div class="col-md-12 customerPO">
              <mat-form-field class="wide100">
                <input matInput type="text" name="firstName" class="pb-1 text-center"
                       [(ngModel)]="element.estimatedAmountToPay"
                       [maxLength]="25"
                       autocomplete="new-username"
                       (keypress)="validateDecimal($event, element)"
                       data-testid="ddl-estimated-spend-search"
                       [disabled]="element.voided || element.retailerAccountNumber == 0 || element.retailerAccountNumber == '' || element.retailerAccountNumber == undefined || !isBudgetExists || isReadOnlyAccess || element.isSpendDisabled">
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="column=='parent'" class="defaultCursor text-left">
            {{element.parent}}
          </div>

          <div class="row">
            <div *ngIf="column=='grower'" class="col-md-12 material-select deliveryInstructionsGrowerProgram smallerWidth">
              <div *ngIf="!element.isSpendDisabled">
                <ng-select name="ddlgrower"
                           [items]="element.growerListFiltered"
                           [clearable]="false"
                           class="custom-select-grower grower-add-drop cpp-return-shipto pb-1 display-ib"
                           [virtualScroll]="true"
                           [(ngModel)]="element.growerNumber"
                           [disabled]="element.voided || element.retailerAccountNumber == 0 || element.retailerAccountNumber == ''|| element.retailerAccountNumber == undefined || !isBudgetExists || isReadOnlyAccess || element.isSpendDisabled"
                           bindLabel="accountName"
                           bindValue="accountNumber"
                           [closeOnSelect]="true"
                           [searchFn]="accountSearchFn"
                           (change)="onGridGrowerInputChange($event, element)"
                           data-testid="ddl-grower-name-search"
                           matTooltipClass='gp-gray-tooltip'
                           [placeholder]="'Type to Search'">
                  <ng-template ng-label-tmp let-item="item" let-index="index">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="mb-0 mt-2" [ngClass]="item.isActive === false ? 'red-color': ''">
                            {{item.accountName}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <h4 [ngClass]="item.isActive === false ? 'name-font red-color': ' name greenColor'" [ngOptionHighlight]="search">
                            {{item.accountName}}
                          </h4>
                          <p [ngClass]="item.isActive === false ? 'red-color': 'address'" [ngOptionHighlight]="search">
                            {{item.accountAddress1}},  {{item.accountCity}}, {{item.accountState}} - {{item.accountZipCode}}
                          </p>
                          <p [ngClass]="item.isActive === false ? 'red-color': 'phoneNo'" [ngOptionHighlight]="search">
                            {{item.primaryPhoneNumber}}
                          </p>
                          <p class="grower-nos">
                            <span class="grower-gln" [ngClass]="item.isActive === false ? 'red-color': ''" [ngOptionHighlight]="search">
                              Account #: {{item.accountNumber}}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-footer-tmp let-search="searchTerm">
                    <div class="custom-drop-footer">
                      <div class="row">
                        <div class="col-lg-8">
                          <button mat-raised-button class="btns" color="primary" (click)="openGrowerSliderModel(i,element.retailerAccountNumber)">Advanced Search</button>
                        </div>
                        <div class="col-lg-4 bold text-left">
                          Results : {{element.growerListCount}}
                        </div>
                      </div>
                    </div>

                  </ng-template>

                </ng-select>
                <span class="display-ib" *ngIf="element.isGrowerActive === false"><i class="fas fa-info-circle inactive-icon" title="This Grower is inactive."></i></span>
              </div>
              <div *ngIf="element.budgetID > 0 && element.spendID > 0 && element.isSpendDisabled">
                <span>{{searchGrowerName(element.growerNumber)}}</span>
              </div>
            </div>
          </div>

          <div #ddlseller *ngIf="column=='seller'" class="col-md-12 padding-l0 material-select deliveryInstructionsGrowerProgram smallerWidth">
            <div *ngIf="!element.isSpendDisabled">
              <ng-select name="ddlseller"
                         [items]="element.sellerListFiltered"
                         [clearable]="false"
                         class="custom-select-grower grower-add-drop cpp-return-shipto pb-1 display-ib"
                         [virtualScroll]="true"
                         [(ngModel)]="element.sellerAccountNumber"
                         [disabled]="element.voided || element.retailerAccountNumber == 0 || element.retailerAccountNumber == ''|| element.retailerAccountNumber == undefined || !isBudgetExists || isReadOnlyAccess || element.isSpendDisabled"
                         bindLabel="accountName"
                         bindValue="accountNumber"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn"
                         (change)="onGridSellerInputChange($event, element)"
                         data-testid="ddl-seller-name-search"
                         matTooltipClass='gp-gray-tooltip'
                         [placeholder]="element.sellerAccountNumber ? '' : 'Type to Search'">
                <ng-template ng-label-tmp let-item="item" let-index="index">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="mb-0 mt-2" [ngClass]="item.isActive === false ? 'red-color': ''">
                          {{item.accountName}}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-10">
                        <h4 [ngClass]="item.isActive === false ? 'name-font red-color': ' name greenColor'" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p [ngClass]="item.isActive === false ? 'red-color': 'address'" [ngOptionHighlight]="search">
                          {{item.accountAddress1}},  {{item.accountCity}}, {{item.accountState}} - {{item.accountZipCode}}
                        </p>
                        <p [ngClass]="item.isActive === false ? 'red-color': 'phoneNo'" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngClass]="item.isActive === false ? 'red-color': ''" [ngOptionHighlight]="search">
                            Seller #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-footer-tmp let-search="searchTerm">
                  <div class="custom-drop-footer">
                    <div class="row">
                      <div class="col-lg-8 d-none d-lg-block">
                      </div>
                      <div class="col-lg-4 bold text-left">
                        Results : {{element.sellerListFiltered.length}}
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
              <span class="display-ib" *ngIf="element.isSellerActive === false"><i class="fas fa-info-circle inactive-icon" title="This Seller is inactive."></i></span>
            </div>
            <div *ngIf="element.budgetID > 0 && element.spendID > 0 && element.isSpendDisabled">
              <span>{{searchSellerName(element.sellerAccountNumber)}}</span>
            </div>

          </div>

          <div *ngIf="column=='budgetUser'">
            <span>{{element.budgetUserName}}</span>
          </div>

          <div *ngIf="column=='programName'" class="col-12  material-select deliveryInstructionsGrowerProgram">
            <div *ngIf="element.programMasterID === 0 || element.spendID === 0">
              <ng-select name="ddlProgramNameLine"
                         [items]="element.programFilteredList"
                         [(ngModel)]="element.programMasterID"
                         [clearable]="true"
                         class="custom-select-grower grower-add-drop custom-productline"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="id"
                         [closeOnSelect]="true"
                         [searchFn]="programAndBudgetSearch"
                         (change)="onGridProgramChange($event, element,programFieldName, i)"
                         [disabled]="!isBudgetExists || element.isExistingRecord"
                         data-testid="ddl-program-name"
                         matTooltip="{{element.programMasterID != 0 ?element.programMasterID : ''}}"
                         [matTooltipPosition]="'left'"
                         matTooltipClass='gp-gray-tooltip'
                         [placeholder]="element.programMasterID > 0? '':'Type to Search'">
                <ng-template ng-footer-tmp let-search="searchTerm">
                  <div class="custom-drop-footer">
                    <div class="row">
                      <div class="col-lg-8">
                        <button mat-raised-button class="btns" color="primary" (click)="openProgramNameSliderModel(element, i)">Show All</button>
                      </div>
                      <div class="col-lg-4 bold text-left">
                        Results : {{element.programFilteredList.length}}
                      </div>
                    </div>

                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div *ngIf="element.programMasterID > 0 && element.spendID > 0"
                 matTooltip="{{element.programMasterID}}"
                 [matTooltipPosition]="'left'"
                 matTooltipClass="gp-gray-tooltip">
              <span>{{searchProgramName(element.programMasterID, element.programFilteredList)}}</span>
            </div>

          </div>

          <div *ngIf="column=='salesChannel'" class="col-12 padding-l0 material-select deliveryInstructionsGrowerProgram">
            <div *ngIf="!element.isSpendDisabled">
              <ng-select name="ddlSalesList"
                         [items]="sales"
                         [(ngModel)]="element.productSegmentId"
                         [clearable]="false"
                         [searchable]="false"
                         class="custom-select-grower grower-add-drop custom-productline"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="id"
                         matTooltipClass='gp-gray-tooltip'
                         [placeholder]="element.productSegmentId > 0? '':'Type to Search'"
                         (change)="onGridInputChangeSales($event, element,salesChannelFieldName, i)"
                         [closeOnSelect]="true"
                         [disabled]="element.voided || element.retailerAccountNumber == 0 || element.retailerAccountNumber == '' || element.retailerAccountNumber == undefined || !isBudgetExists || isReadOnlyAccess || element.isSpendDisabled"
                         data-testid="ddl-sales-channel-search">
              </ng-select>
            </div>
            <div *ngIf="element.productSegmentId > 0 && element.spendID > 0 && element.isSpendDisabled">
              <span>{{searchProductSegment(element.productSegmentId)}}</span>
            </div>
          </div>

          <div *ngIf="column=='marketingBrand'" class="col-12 padding-l0 material-select deliveryInstructionsGrowerProgram">
            <div *ngIf="!element.isSpendDisabled">
              <ng-select name="ddlMarketingBrandList"
                         [items]="marketingList"
                         [(ngModel)]="element.marketingBrandId"
                         [clearable]="false"
                         [searchable]="false"
                         class="custom-select-grower grower-add-drop custom-productline"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="id"
                         [closeOnSelect]="true"
                         (change)="onGridInputChange($event,element)"
                         [disabled]="element.voided || element.retailerAccountNumber == 0 || element.retailerAccountNumber == '' || element.retailerAccountNumber == undefined || !isBudgetExists || isReadOnlyAccess || element.isSpendDisabled"
                         data-testid="ddl-marketing-brand-search"
                         matTooltipClass='gp-gray-tooltip'
                         [placeholder]="element.marketingBrandId ? '' : 'Type to Search'">
              </ng-select>
            </div>
            <div *ngIf="element.marketingBrandId != '' && element.spendID > 0 && element.isSpendDisabled">
              <span>{{searchMarketingBrand(element.marketingBrandId)}}</span>
            </div>

          </div>

          <div *ngIf="column=='productLine'" class="col-12 padding-l0 material-select deliveryInstructionsGrowerProgram">
            <div *ngIf="!element.isSpendDisabled">
              <ng-select name="ddlProductLine"
                         [items]="productLineList"
                         [(ngModel)]="element.productLineId"
                         [clearable]="false"
                         [searchable]="false"
                         class="custom-select-grower grower-add-drop custom-productline"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="id"
                         [closeOnSelect]="true"
                         (change)="onGridInputChange($event, element)"
                         [disabled]="element.voided || element.retailerAccountNumber == 0 || element.retailerAccountNumber == '' || element.retailerAccountNumber == undefined || !isBudgetExists || isReadOnlyAccess || element.isSpendDisabled"
                         data-testid="ddl-product-line-search"
                         matTooltipClass='gp-gray-tooltip'
                         [placeholder]="element.productLineId ? '':'Type to Search'">
              </ng-select>
            </div>
            <div *ngIf="element.productLineId != '' && element.spendID > 0 && element.isSpendDisabled">
              <span>{{searchProductLine(element.productLineId)}}</span>
            </div>

          </div>

          <div *ngIf="column=='cyOrder'" class="defaultCursor text-center">
            {{element.growerOrderQTY}}
          </div>

          <!--<div *ngIf="column=='approvedPayment'" class="text-center firstName w100">
            <div class="col-md-12 customerPO">
              <mat-form-field class="wide100">
                <input matInput type="text" name="firstName" class="pb-1"
                       [(ngModel)]="element.approvedAmountToPay"
                       [maxLength]="25"
                       autocomplete="new-username"
                       (keypress)="validateDecimal($event)"
                       [readonly]="true"
                       data-testid="ddl-approved-payment-search">
              </mat-form-field>
            </div>
          </div>-->
          <!--<div *ngIf="column=='customerCreditedAmount'" class="text-center firstName w100">
            <div class="col-md-12 customerPO">
              <mat-form-field class="wide100">
                <input matInput type="text" name="firstName" class="pb-1"
                       [(ngModel)]="element.customerCreditAmount"
                       [maxLength]="25"
                       autocomplete="new-username"
                       (keypress)="validateDecimal($event)"
                       [readonly]="true"
                       data-testid="ddl-customer-credited-amount-search">
              </mat-form-field>
            </div>
          </div>-->

          <div *ngIf="column=='status'" class="defaultCursor text-center">
            {{element.status}}
            <span class="display-ib" *ngIf="element.jdeorderNumber != null"><i class="fas fa-info-circle inactive-icon" (click)="jDEDetails(element)"></i></span>
          </div>

          <div *ngIf="column=='responsible'" class="defaultCursor text-center">
            {{element.responsible}}
          </div>

          <div *ngIf="column=='approvedPayment'" class="defaultCursor text-center">
            {{element.approvedAmountToPay}}
          </div>

          <div *ngIf="column=='customerCreditedAmount'" class="defaultCursor text-center">
            {{element.customerCreditAmount}}
          </div>
          <div *ngIf="column=='updateTimestamp'" class="defaultCursor text-center">
            {{element.updateTimestamp | date:'MM/dd/yyyy HH:mm:ss'}}
          </div>

          <div *ngIf="column=='comment' && element.spendID > 0" class="defaultCursor text-center">
            <div class="col-12">
              <i title="Comments On Spend"
                 class="fas fa-solid fa-tag"
                 [class.handCursor]="!element.voided"
                 (click)="!element.voided && openCommentSliderModel(element, i)"></i>
            </div>
          </div>
        </td>
        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <div class="inline-error" *ngIf="element.lineErrors && element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.itemId}}">
              <div class="row">
                <div class="col-md-9">
                  <ol class="error-list">
                    <li *ngFor="let err of element.lineErrors.errors">
                      {{err.error}}
                  </ol>
                </div>
                <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                  <span>
                    Revert to Previous.
                    <i class="icon-ico-Reply"></i>
                  </span>
                </div>
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;"
            class="example-element-row" [ngClass]="{'voided-row': element.voided}"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" [hidden]="this.showErrorBlock != true"></tr>
        </table>
      </div>
    </div>
    <div class="common-error-block new-return-request" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index]?.errors?.length > 0">
      <div class="row">
        <div class="col-md-2 padding-r0 errCountOuter">
          <span class="errorCounting">
            {{currentErrorRow}} of {{errorMsgs.length}}
          </span>
        </div>
        <div class="col-md-6 padding-l0 ">
          <ul class="errorMsg">
            <li *ngFor="let err of errorMsgs[index].errors">
              <p> {{err.error}}</p>
            </li>

          </ul>
        </div>

        <div class="col-md-4 button-sec text-right">
          <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
          <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()">Next Error</button>
        </div>
      </div>
    </div>

  </div>
</div>
